import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { APIService } from "./api.service";
import { PushNotificationService } from "./push-notification.service";
import { Constants } from 'src/app/shared/constants';
import { AppConfigService } from "./app-config/app-config.service";

@Injectable({
    providedIn: 'root'
})
export class ElevatorCallService {

    constructor(private _pushNotificationService: PushNotificationService, private _localCookies: CookieService, private _apiService: APIService) { }

    closePushNotification() {
        this._pushNotificationService.closeNotification(this._localCookies.get('CCApp-elevatorID'));
    }

    getVideoStats() {
        return { enabledEle: false, auto: false, frameMessage: '', enableAgentVideo: true, remAudioBytesReceived: '', remAudioCodec: '', remVideoBytesReceived: '', remVideoCodec: '', RemFramesRate: '', remDimension: '', remPacketsLost: 0, remPacketsReceived: 0, remSSRC: 0, remJitter: 0, remAudioPocketReceived: 0, remAudioPocketLost: 0, remAudioSSRC: 0, locAudioBytesReceived: '', locAudioCodec: '', locVideoBytesReceived: '', locVideoCodec: '', locFramesRate: '', locDimension: '', locPacketsLost: 0, locPacketsSent: 0, locRoundTripTime: 0, locSSRC: 0, locJitter: 0, locAudioPocketSent: 0, locAudioPocketLost: 0, locAudioRoundTripTime: 0, locAudioSSRC: 0 };
    }
    updateCall(payload: any) {
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - updateCall" }, { url: Constants.elevator_call_URLS.updateCall, payload: payload });
        return this._apiService.post(payload, Constants.elevator_call_URLS.updateCall)
    }
    insertChatMsgDetails(payload: any) {
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - insertChatMsgDetails" }, { url: Constants.elevator_call_URLS.insertChatMsgDetails, payload: payload });
        return this._apiService.post(payload, Constants.elevator_call_URLS.insertChatMsgDetails)
    }
    insertCallDetails(payload: any) {
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - insertCallDetails" }, { url: Constants.elevator_call_URLS.insertCallDetails, payload: payload });
        return this._apiService.post(payload, Constants.elevator_call_URLS.insertCallDetails);
    }
    updateCallDetails(payload: any) {
        //payload.buildingAddress = null;
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - updateCallDetails" }, { url: Constants.elevator_call_URLS.updateCallDetails, payload: payload });
        return this._apiService.post(payload, Constants.elevator_call_URLS.updateCallDetails);
    }
    getElevatorDetails(payload: any) {
        // construct URL
        var ElevatorInfo:any={};
        if (payload.callerId != undefined)
        {
            ElevatorInfo = Constants.G3MS_URLS.getElevatorInfo + '?alarm_id=' + payload.alarm_id + '&callerId=' + payload.callerId + '&countryId=' + payload.countryId+'&elevatorId='+ payload.elevatorId +'&remGroupId='+payload.remGroupId;
            ////ElevatorInfo = Constants.G3MS_URLS.getElevatorInfo + '?alarm_id=' + payload.alarm_id + '&countryId=' + payload.countryId+'&elevatorId='+ payload.elevatorId;
        }
        else{
            ElevatorInfo = Constants.G3MS_URLS.getElevatorInfo + '?alarm_id=' + payload.alarm_id + '&countryId=' + payload.countryId+'&elevatorId='+ payload.elevatorId;
        }
        ////const ElevatorInfo = Constants.G3MS_URLS.getElevatorInfo + '?alarm_id=' + payload.alarm_id + '&callerId=' + payload.callerId + '&countryId=' + payload.countryId+'&elevatorId='+ payload.elevatorId +'&remGroupId='+payload.remGroupId;
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - getElevatorDetails" }, { url: Constants.G3MS_URLS.getElevatorInfo, payload: payload });
        return this._apiService.post(payload, ElevatorInfo);
    }
    callBackElevatorFromG3MS(payload: any) {
        //AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - callBackElevatorFromG3MS" }, { url: Constants.G3MS_URLS.callbackFromElevator, payload: payload });
        //return this._apiService.post(payload, Constants.G3MS_URLS.callbackFromElevator);
    }
    getIdentityToken(payload: any) {
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - getIdentityToken" }, { url: Constants.elevator_call_URLS.getIdentityToken, payload: payload });
        return this._apiService.post(payload, Constants.elevator_call_URLS.getIdentityToken+'?identity='+payload.identityName);
    }
    getVoiceIdentityToken(payload: any) {
    return this._apiService.post(payload, Constants.elevator_call_URLS.getVoiceIdentityToken);
  }
    getWorkersForSupervisor(payload: any) {
        //AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - getWorkersForSupervisor" }, { url: Constants.elevator_call_URLS.getWorkersForSupervisor, payload: payload });
        return this._apiService.post(payload, Constants.SUPERVISOR_DASHBOARD_URLS.getWorkersForSupervisor);
    }
    transferCall(payload: any) {
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - transferCall" }, { url: Constants.elevator_call_URLS.callTransfer, payload: payload });
        return this._apiService.post(payload, Constants.elevator_call_URLS.callTransfer);
    }
    saveDispositionDetails(payload: any) {
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - saveDispositionDetails" }, { url: Constants.call_disposition_URLS.saveCallDisposition, payload: payload });
        return this._apiService.post(payload, Constants.call_disposition_URLS.saveCallDisposition);
    }
    getElevatorCallsDetails(payload: any) {
        //AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - getElevatorCallsDetails" }, { url: Constants.elevator_call_URLS.retrieveCallDetailsCountry, payload: payload });
        //return this._apiService.post(payload, Constants.elevator_call_URLS.retrieveCallDetailsCountry);
    }
    getCallsDetailsElevator(payload: any) {
        let url = Constants.elevator_call_URLS.retrieveCallDetailsElevator + `?elevatorId=${payload.elevatorId}`;
        ////let url = Constants.elevator_call_URLS.retrieveCallDetailsElevator + `?elevatorId=${payload.alarmId}`;
        //AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - getCallsDetailsElevator" }, { url: url, payload: payload });
        return this._apiService.post(payload, url);
    }
    getWorkerCallActivities(payload: any) {
        //AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - getWorkerCallActivities" }, { url: Constants.elevator_call_URLS.getWorkerCallActivities, payload: payload });
        return this._apiService.post(payload, Constants.elevator_call_URLS.getWorkerCallActivities);
    }
    getTPAStatus(payload: any) {
        //AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - getTPAStatus" }, { url: Constants.elevator_call_URLS.getTPAStatus, payload: payload });
        return this._apiService.post(payload, Constants.elevator_call_URLS.getTPAStatus);
    }
    saveDisplayElevatorNumber(payload: any) {
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - saveDisplayElevatorNumber" }, { url: Constants.elevator_call_URLS.saveElevatorUnitNumberForFactoryNo, payload: payload });
        return this._apiService.post(payload, Constants.elevator_call_URLS.saveElevatorUnitNumberForFactoryNo);
      }
      updateNotes(payload: any) {
        const updateNotesInfo = Constants.elevator_call_URLS.updateNotes + '?alarm_id=' + payload.alarm_id + '&callerId=' + payload.incidentId + '&countryId=' + payload.notes;
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - updateNotes" }, { url: Constants.elevator_call_URLS.updateNotes, payload: payload });
        return this._apiService.post(payload, updateNotesInfo);
    }
}